import React from 'react';
import PropTypes from 'prop-types';
import withData from '@bd/bdcore-data';
import { css } from '@bd/bdui-styles/emotion';
import { get, has, orderBy } from 'lodash';
import moment from 'moment';
import { Link } from '@bd/bdcore-named-routes';
import { SanitizeHtml, Image } from '@bd/bdcore-utilities';
import { colors } from '../../../styles';

const styles = css`
  padding: 40px 15px;
  @media(min-width: 992px) {
    padding: 80px 0 40px;
  }
  img {
    max-width: 100%;
  }
  .Blogpost_image {
    width: 100%;
    margin: 0 0 30px 0;
  }
  .Blogpost_date {
    font-weight: 700;
    font-size: 15px;
    color: ${colors.body};
    letter-spacing: 0.42px;
    line-height: 16px;
    margin-bottom: 40px;
    @media(min-width: 992px) {
      font-size: 17px;
      letter-spacing: 0.47px;
    }
    .Blog_tagList {
      display: none;
      position: relative;
      text-transform: capitalize;
      &::before {
        content: '|';
        margin-left: -5px;
      }
      @media(min-width: 992px) {
        display: flex;
        flex-wrap: wrap;
        list-style: none;
        padding: 0;
        margin-left: 15px;
      }
      li a {
        color: ${colors.brand2};
        transition: all .3s ease-out;
        @media(min-width: 992px) {
        }
        &:first-child {
          padding-left: 10px;
        }
        &:hover {
          color: ${colors.brand1};
          transition: all .3s ease-out;
        }
      }
      li::after {
        color: ${colors.brand4};
        content: ',';
      }
      li:last-child::after {
        content: '';
      }
    }
  }
  .Blog_tag {
    text-transform: capitalize !important;
  }
  .Blogpost_title {
    font-weight: 700;
    position: relative;
    font-size: 21px;
    color: ${colors.body};
    line-height: 28px;
    @media(min-width: 992px) {
      text-transform: uppercase;
      font-size: 40px;
      color: ${colors.body};
      line-height: 48px;
    }
    &::after {
      @media(min-width: 992px) {
        content: '';
        display: block;
        width: 125px;
        background-color: ${colors.brand3};
        height: 3px;
        position: relative;
        margin: 30px 0;
      }
    }
  }
  .Blogposts {
    display: block;
    position: relative;
    padding: 0 0 45px 0;
    img {
      width: 100%;
      margin: 0 0 15px 0;
    }
    .Blogposts_title {
      transition: all .3s ease-out;
      margin-bottom: 10px;
      font-weight: 700;
      font-size: 16px;
      color: ${colors.body};
      line-height: 1.2;
      @media(min-width: 992px) {
        font-size: 21px;
      }
      &:hover {
        color: ${colors.brand1};
        transition: all .3s ease-out;
      }
    }
  }
  @media (min-width: 992px) {
    .Blogposts {
      &:after {
        background-color: ${colors.brand1};
        width: 125px;
      }
    }
  }
  .blog_sidebarHeading {
    font-weight: 700;
    margin-bottom: 25px;
    text-transform: uppercase;
    font-size: 18px;
    color: ${colors.body};
    letter-spacing: 4.29px;
    margin-bottom: 50px;
    position: relative;
    @media(min-width: 992px) {
      font-size: 24px;
      letter-spacing: 3px;
    }
    &::after {
      content: '';
      position: absolute;
      left: 0;
      bottom: -25px;
      width: 75px;
      height: 3px;
      background-color: ${colors.brand3};
    }
  }
  .Blogposts_date  {
    font-weight: 700;
    font-size: 12px;
    color: ${colors.brand2};
    line-height: 1px;
    margin: 0 0 30px 0;
    @media(min-width: 992px) {
      font-size: 15px;
      color: ${colors.brand2};
      letter-spacing: 0;
    }
  }
  .Blogposts_latest {
    padding-top: 40px;
    background-color: ${colors.neutral};
    @media(min-width: 576px) {
      padding: 0 60px;
    }
    @media(min-width: 992px) {
      background-color: transparent;
      max-width: 31% !important;
      padding: 0 40px 40px 40px;
      height: 100%;
    }
  }
  .Blogpost_body {
    font-weight: 400;
    font-size: 14px;
    color: ${colors.body};
    letter-spacing: 0;
    line-height: 25px;
    @media(min-width: 992px) {
      font-weight: 300;
      font-size: 17px;
      line-height: 29px;
      border-bottom: 1px solid ${colors.neutral};
      padding-bottom: 15px;
      margin-bottom: 30px;
    }
    strong {
      color: ${colors.black};
      font-weight: 700;
    }
    a {
      font-weight: 700;
      color: ${colors.brand2};
      text-decoration: underline;
      &:hover {
        color: ${colors.brand2Lightest};
      }
    }
    span {
      font-weight: 300;
      font-size: 21px;
      color: ${colors.brand3};
      letter-spacing: 0;
      line-height: 37px;
      @media(min-width: 992px) {
        font-size: 24px;
        line-height: 45px;
      }
    }
    em {
      font-style: italic;
      font-weight: 300;
    }
  }
  .Blogposts_categories {
    display: none;
    @media(min-width: 992px) {
      display: flex;
    }
  }

  .Blogpost_tags {
    display: none;
    @media(min-width: 992px) {
      display: flex;
    }
    .Blog_tagList {
      list-style: none;
      padding: 0 0 0 5px;
      display: flex;
      flex-wrap: wrap;
      font-weight: 700;
      font-size: 17px;
      color: ${colors.body};
      letter-spacing: 0;
      line-height: 29px;

      li {
        margin-right: 7px;
        position: relative;
        &::after {
          content: ', '
        }
        &:last-child {
          &::after {
            content: none;
          }
        }
      }
    }
  }
  .Blogpost_other {
    width: 260px;
    display: flex;
    flex-direction: column;
    transition: all .3s ease-out;
    &:hover {
      opacity: 0.4;
    }
    .Blogpost_otherTitle {
      font-weight: 700;
      font-size: 17px;
      color: ${colors.body};
      letter-spacing: 0;
    }
    .Blogpost_otherLink {
      font-weight: 700;
      font-size: 17px;
      color: ${colors.brand3};
      letter-spacing: 0;
    }
    .Blogpost_otherImage {
      width: 100%;
      height: 140px;
      object-fit: cover;
      margin: 0 0 10px 0;
    }

    &:first-child {
      margin-right: 20px;
    }
  }
`;

function BlogpostDetail({ blogpost, blogposts }) {
  const latestPosts = blogposts.filter(item => item._id !== get(blogpost, '_id'));

  let previous = null;
  let next = null;

  const posts = orderBy(blogposts, 'date', 'desc');
  const index = posts.indexOf(blogpost);

  if (index === 0) {
    previous = null;
    next = posts[index + 1];
  }

  if (index > 0) {
    previous = posts[index - 1];
    next = posts[index + 1];
  }
  if (index === posts.length - 1) {
    previous = posts[index - 1];
    next = null;
  }

  return (
    <div className={styles}>
      <div className="container">
        <div className="row">
          <div className="col-lg-8">
            <h1 className="Blogpost_title">{get(blogpost, 'title')}</h1>
            <h4 className="Blogpost_date">
              {
                has(blogpost, 'date') &&
                moment(get(blogpost, 'date')).format('MMMM D, YYYY')
              }
            </h4>
            <Image
              src={get(blogpost, 'logo.contentUrl')}
              alt={get(blogpost, 'logo.name', '')}
              width={800}
              height={800}
              className="Blogpost_image"
            />
            <div className="Blogpost_body" dangerouslySetInnerHTML={SanitizeHtml(get(blogpost, 'htmlbody'))} />
            {
              blogpost.tags &&
              <span className="Blogpost_tags">
                Tags:
                <ul className="Blog_tagList">
                  {
                    get(blogpost, 'tags', '').split(',').filter(t => t).map(tag => (
                      <li key={tag} className="Blog_tag">
                        <Link name="blog-tag" params={{ blogTag: tag }}>{tag}</Link></li>
                      ))
                    }
                </ul>
              </span>
              }
          </div>
          <div className="col-lg-4 ml-auto Blogposts_latest">
            <div className="Blogposts">
              <h3 className="blog_sidebarHeading">Recent Articles</h3>
              {
                orderBy(latestPosts, 'date', 'desc').slice(0, 9).map(post => (
                  <Link name="blogpost-detail" params={{ blogpostTitle: post.title }} key={post._id}>
                    <h3 className="Blogposts_title">{post.title}</h3>
                    <h4 className="Blogposts_date">
                      {
                        has(post, 'date') &&
                        moment(get(post, 'date')).format('MMMM D, YYYY')
                      }
                    </h4>
                  </Link>
                ))
              }
            </div>
          </div>
        </div>
        <div className="row d-none d-lg-flex my-5 justify-content-start">
          {
            previous !== null &&
            <div className="Blogpost_other">
              <h4 className="Blogpost_otherTitle">Previous Article</h4>
              <Link name="blogpost-detail" params={{ blogpostTitle: get(previous, 'title') }}>
                <Image
                  src={previous.logo.contentUrl}
                  alt={get(previous, 'logo.name', '')}
                  width={400}
                  height={400}
                  className="Blogpost_otherImage"
                />
                <h3 className="Blogpost_otherLink">{get(previous, 'title')}</h3>
              </Link>
            </div>
          }
          {
            next !== null &&
            <div className="Blogpost_other">
              <h4 className="Blogpost_otherTitle">Next Article</h4>
              <Link name="blogpost-detail" params={{ blogpostTitle: get(next, 'title') }}>
                <Image
                  src={next.logo.contentUrl}
                  alt={get(next, 'logo.name', '')}
                  width={400}
                  height={400}
                  className="Blogpost_otherImage"
                />
                <h3 className="Blogpost_otherLink">{get(next, 'title')}</h3>
              </Link>
            </div>
          }
        </div>
      </div>
    </div>
  );
}

BlogpostDetail.propTypes = {
  blogpost: PropTypes.object.isRequired,
  blogposts: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default withData(
  {
    blogpost: true,
    blogposts: true,
  },
  {
    ifMissing404: true,
  },
)(BlogpostDetail);



// WEBPACK FOOTER //
// ./src/components/PageLoader/Sections/BlogDetail.section.js